import axiosInstance from 'helpers/axiosInstance';

export enum FlagRefKinds {
  Custody = 'CUSTODY',
}

export const addFlagToMember = (kind: FlagRefKinds, memberId: string) => {
  return axiosInstance.post(`/patients/patients/${memberId}/flags`, {
    flag: {
      refFlagCode: kind,
    },
  });
};
